import { AnyAction } from 'redux';

import {
    CLEAR_SESSION_AND_USER,
    UPDATE_SAVED_SESSION,
    UPDATE_USER,
    UPDATE_FAVORITES,
    UPDATE_CC_ACTION,
} from '../Actions/UserActions';

import initialState from './UserInitialState';

const reducer = (state = initialState, action: AnyAction): typeof initialState => {
    switch (action.type) {
        case CLEAR_SESSION_AND_USER:
            return {
                savedSession: {
                    sessionCode: '',
                    medications: undefined,
                    providers: undefined,
                },
                user: {
                    isLoggedIn: false,
                    data: {},
                },
                planFavorites: 0,
                ccAction: '',
            };
        case UPDATE_SAVED_SESSION:
            return {
                ...state,
                savedSession: action.payload as typeof initialState.savedSession,
            };
        case UPDATE_USER:
            return {
                ...state,
                user: action.payload as typeof initialState.user,
            };
        case UPDATE_FAVORITES:
            return {
                ...state,
                planFavorites: action.payload as number,
            };
        case UPDATE_CC_ACTION:
            return {
                ...state,
                ccAction: action.payload as string,
            };
        default:
            return state;
    }
};
export default reducer;
